import { HttpInterceptorFn, HttpErrorResponse, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import {Observable, throwError } from 'rxjs';

import { DefaultErrorMessage, ErrorMessages } from '../components/catalogoErrores/error-messages';
import Swal from 'sweetalert2';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Angular solo entra aquí si el error es real (status 4xx o 5xx)
      const statusCode = error.status;
      const message = ErrorMessages[statusCode] ?? DefaultErrorMessage;

      // Opcional: mostrar alerta o log
      console.log(error);
      console.error();

      return throwError(() => new Error(message));
    })
  );

};


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
 intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      // ⚠️ Manejo de respuestas exitosas (200 OK)
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.status === 200) {
          // Aquí puedes filtrar por URL si solo quieres mostrar el SweetAlert para ciertos endpoints


          // También podrías hacer validaciones por contenido si lo deseas:
          // if (event.body?.datosVehiculoResponseVo?.strModelo) { ... }
        }
      }),

      // ⚠️ Manejo de errores
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        const statusCode = error.status;

        if (error.error?.idCodigo && ErrorMessages[error.error.idCodigo]) {
          errorMessage = ErrorMessages[error.error.idCodigo];
        } else if (error.error instanceof ErrorEvent) {
          errorMessage = `Error de cliente: ${error.error.message}`;
        } else if (error.error?.descripcionCodigo) {
          errorMessage = error.error.descripcionCodigo;
        } else if (ErrorMessages[statusCode]) {
          errorMessage = ErrorMessages[statusCode];
        } else {
          errorMessage = DefaultErrorMessage;
        }

        // Mostrar alerta de error
        Swal.fire('Error', errorMessage, 'error');
        console.error();

        return throwError(() => this.buildErrorObject(error, errorMessage));
      })
    );
  }

  private buildErrorObject(error: HttpErrorResponse, message: string): any {
    return {
      originalError: error,
      userMessage: message,
      timestamp: new Date().toISOString()
    };
  }
}
